var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 841.9 465.3" },
      attrs: {
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:cc": "http://creativecommons.org/ns#",
        "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
        "xmlns:svg": "http://www.w3.org/2000/svg",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
        "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
        version: "1.1",
        id: "Livello_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 841.9 465.3",
        "xml:space": "preserve",
        "sodipodi:docname": "personal-name-position.svg",
        "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
      },
    },
    [
      _c(
        "metadata",
        { attrs: { id: "metadata48" } },
        [
          _c(
            "rdf:RDF",
            [
              _c(
                "cc:Work",
                { attrs: { "rdf:about": "" } },
                [
                  _c("dc:format", [_vm._v("image/svg+xml")]),
                  _c("dc:type", {
                    attrs: {
                      "rdf:resource": "http://purl.org/dc/dcmitype/StillImage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("defs", { attrs: { id: "defs46" } }),
      _c("sodipodi:namedview", {
        attrs: {
          pagecolor: "#ffffff",
          bordercolor: "#666666",
          borderopacity: "1",
          objecttolerance: "10",
          gridtolerance: "10",
          guidetolerance: "10",
          "inkscape:pageopacity": "0",
          "inkscape:pageshadow": "2",
          "inkscape:window-width": "1920",
          "inkscape:window-height": "1052",
          id: "namedview44",
          showgrid: "false",
          "inkscape:zoom": "0.50719967",
          "inkscape:cx": "420.95001",
          "inkscape:cy": "232.64999",
          "inkscape:window-x": "1920",
          "inkscape:window-y": "0",
          "inkscape:window-maximized": "1",
          "inkscape:current-layer": "Livello_1",
        },
      }),
      _c("g", { attrs: { id: "g36" } }, [
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M841.9,46.8c-18.2,0.2-36.1,3.6-52.6,10.8c-10.7,4.7-21.4,4.4-32.2,3.9c-12.6-0.5-25.2-2.5-37.8-3.3   c-14.6-0.9-29.3-1.5-44-1.8c-31.5-0.5-63-0.9-94.5-0.8c-15.4,0-30.8,0.9-46.2,1.7c-13.2,0.7-26.4,1.7-39.6,2.6   c-7,0.5-14.1,1-21.1,1.8c-9.8,1-19.6,2.4-29.5,3.5c-6.7,0.7-13.5,1.1-20.2,1.8c-5.7,0.7-11.4,1.8-17.2,2.6   c-5.1,0.7-10.3,1.2-15.4,1.8c-8.2,1-16.4,1.9-24.6,3.1c-7.9,1.2-15.8,2.6-23.7,3.9c-12.9,2.2-25.8,4.3-38.7,6.6   c-14.2,2.6-28.5,5.3-42.6,8.4c-16.6,3.7-33.2,7.7-49.7,11.9c-20.6,5.2-41.1,10.5-61.5,16.3c-17.3,4.9-34.3,10.6-51.5,15.7   C72.7,145.1,47,155.2,21,164.6c-8.5,3.1-13.1,8.4-8.4,19.9c5.4,13.2,9.9,26.7,15.1,39.9c1.6,4.1,3.9,8.3,8.7,9.1   c2.6,0.4,5.7-0.3,8.3-1.2c21-7.1,41.9-14.4,62.9-21.5c11.2-3.8,22.6-7.4,33.9-11c1.2-0.4,2.6-0.3,3.9-0.5",
            id: "path4",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M739.9,124.6c-10.6-1.6-21.1-3.5-31.7-4.8c-12.3-1.5-24.6-2.5-36.9-3.6c-8-0.7-16.1-1.5-24.2-1.7   c-20.7-0.5-41.3-1-62-0.8c-15.1,0.1-30.2,0.9-45.3,1.7c-16.4,0.9-32.8,2.3-49.2,3.5c-7.9,0.6-15.8,1-23.7,1.8   c-9.5,1-19.1,2.4-28.6,3.4c-6.1,0.7-12.3,1.1-18.5,1.8c-7.1,0.9-14.1,2-21.1,3c-9.4,1.3-18.8,2.6-28.1,4   c-8.2,1.2-16.4,2.6-24.6,3.9c-8.5,1.3-17,2.5-25.5,4c-9.1,1.6-18.2,3.4-27.3,5.3c-10.7,2.2-21.4,4.8-32.1,7   c-14.7,3-28.8,7.8-39.4,18.7c-6.5,6.7-14,9.5-22.6,11.8c-17.1,4.5-34,9.6-51,14.4c-0.7,0.2-1.5,0.3-2.2,0.4",
            id: "path6",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M767.1,129c-5.5,9-10.6,18.2-18.4,25.6c-3.6,3.4-7.4,5.1-12.4,4.8c-5.7-0.4-11.4-0.7-17.1-0.9   c-3.6-0.1-6.5-1.8-8.8-4.4c-5.2-5.9-12-7.8-19.4-7.8c-38.5-0.4-77.1-0.9-115.6-0.8c-15.5,0-31.1,1.6-46.6,2.5   c-6.6,0.4-13.2,0.4-19.8,0.9c-10,0.7-19.9,1.8-29.9,2.6c-4.5,0.4-9.1,0.4-13.6,0.9c-9.8,1.1-19.6,2.3-29.5,3.5   c-8.2,0.9-16.4,1.6-24.6,2.7c-7.1,0.9-14.1,2.3-21.1,3.5c-6,0.9-12,1.8-18,2.7c-8.1,1.2-16.1,2.2-24.2,3.6   c-9.7,1.6-19.4,3.4-29,5.3c-8.2,1.5-16.4,3.1-24.6,4.8c-22,4.8-44,9.5-65.9,14.6c-12.1,2.8-24,6.4-36.1,9.6   c-10.1,2.7-20.1,6.2-30.4,7.6c-7.3,1-15-0.9-21.9-4.1c-2-0.9-3.8-2.3-5.7-3.5",
            id: "path8",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M841.9,113.6c-12.3-0.3-23.5,4.1-34.7,8.4c-9.2,3.5-18.6,5.8-28.6,5.7c-6.3-0.1-12.6,0.4-18.9-0.1   c-6.2-0.5-12.3-1.9-18.3-2.9c-3,2.5-5.8,5.2-8.9,7.4c-9.3,6.8-20,8.1-31.2,7.5c-10.4-0.5-20.8-1.1-31.2-1.3   c-20.5-0.3-41-0.6-61.6-0.4c-21.1,0.2-42.2,0.5-63.3,1.4c-16.1,0.7-32.2,2.3-48.4,3.4c-8.5,0.6-17,1-25.5,1.8   c-10.4,1-20.8,2.3-31.2,3.5c-10.4,1.2-20.8,2.2-31.2,3.6c-11.2,1.5-22.3,3.5-33.4,5.2c-7.6,1.2-15.3,2.3-22.9,3.5   c-9,1.5-17.9,3.2-26.8,4.8c-7.3,1.3-14.7,2.5-22,4c-12,2.4-24.1,4.8-36,7.5c-15.6,3.5-31.1,7.2-46.6,11   c-11.5,2.9-22.9,6.2-34.3,9.2c-10.4,2.7-20.6,6.8-31.6,5.7c-3.1-0.3-6.2-1.4-9.2-2.1",
            id: "path10",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M37.3,234.5c-0.9,16.4-1.8,32.8-2.6,49.2c-0.4,6.9-0.6,13.8-0.9,20.7c-0.3,7.5-0.6,15-0.9,22.4   C32,345.9,31.1,365,30.2,384c-0.3,7-0.6,14.1-0.9,21.1c-0.3,6.9-0.6,13.8-0.9,20.7c-0.6,12.9-1.2,25.8-1.8,38.7",
            id: "path12",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M73.8,223.5c-0.7,19.9-1.4,39.9-2.2,59.8c-0.5,12.9-1.2,25.8-1.7,38.7c-0.9,20.2-1.8,40.5-2.6,60.7   c-0.6,12.9-1.2,25.8-1.8,38.7c-0.6,13.8-1.2,27.6-1.8,41.3c0,0.5-0.3,1-0.4,1.5",
            id: "path14",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M128.7,205.1c0.5,1.5,1,3,1.2,3.5c-0.8,5.4-1.5,9.9-2.1,14.5c-0.9,7.8-1.5,15.6-2.7,23.3   c-1.5,10-6.5,18.2-13.5,25.6c-10.1,10.9-19.5,22.5-29.1,33.7",
            id: "path16",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M128.7,207.3c-13.2,4.7-26.4,9.4-39.6,14.1",
            id: "path18",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M123,247.7c-4.2-12-12.3-15.5-22-13.6c-4.7,0.9-8,3.6-10.6,7.5",
            id: "path20",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M740.3,125.9c-1.3,9.8-6.3,17.9-12.4,25.5c-2.1,2.6-4.9,4.7-7.4,7.1",
            id: "path22",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M103.2,264.9c9.6,1.1,17.7-8.3,14.1-18c-2.2-5.9-9.1-10.9-18.1-7",
            id: "path24",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M108.1,264c-3.3-7.7-6.5-15.5-9.8-23.2c-10.7,6.6-6.4,20.2,3.2,23.2",
            id: "path26",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: { d: "M102.8,239.4c3.1,7.5,6.2,14.9,9.2,22.4", id: "path28" },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: {
            d: "M87.4,218.7c1.3,2.5,2.5,5,3.7,7.2c-0.6,5.8-1.3,11.4-1.9,17c-0.6,5.2-2.6,7.1-7.9,7c-2.6,0-5.3-0.3-7.9-0.4",
            id: "path30",
          },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: { d: "M90.9,295.2c-6.4-0.6-12.9-1.2-19.3-1.8", id: "path32" },
        }),
        _c("path", {
          staticClass: "st0",
          class: { dark: _vm.darkTheme },
          attrs: { d: "M71.1,306.2c3.5,0.1,7,0.3,10.6,0.4", id: "path34" },
        }),
      ]),
      _c("path", {
        staticClass: "st1",
        staticStyle: {
          fill: "none",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "10",
        },
        attrs: {
          id: "personal-name-path",
          d: "M 52,207 C 52,207 338,97 582,102",
          "inkscape:connector-curvature": "0",
        },
      }),
      _c("text", { attrs: { "font-size": "250%", id: "text41" } }, [
        _c(
          "textPath",
          {
            staticClass: "personal-name-text",
            style: { fill: _vm.colore ? _vm.colore.colorCode : "#000000" },
            attrs: {
              "xlink:href": "#personal-name-path",
              startOffset: "5%",
              id: "textPath39",
            },
          },
          [_vm._v(" " + _vm._s(_vm.name) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }